import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../store";

export const routerSelector =  createSelector((state: RootState) => state, (state) => state.router)
